import React, { useEffect } from 'react'
import { SumaryOrders } from './panels/SumaryOrders'
import { Accounts } from './panels/Accounts'
import { useDispatch, useSelector } from 'react-redux';
import { startloadAccounts } from '../../../app/store/reportes/thunks';
import { MDetail } from './modals/MDetail';
import { Performance } from './panels/Performance';
import { PostOrder } from './panels/PostOrder';
import { PostService } from './panels/PostService';
import { ServicesComplete } from './panels/ServicesComplete';
import { Birthdays } from './panels/Birthdays';
import { ProfistCustomer } from './panels/ProfistCustomer';
import { ServicesMinMax } from './panels/ServicesMinMax';
import { GraficLine } from '../../utils/GraficLine';
import { MaxMin } from '../../pages/reports/panels/MaxMin';
import { Frecuencia } from '../../pages/reports/panels/Frecuencia';
import { IngresosByOrden } from './panels/IngresosByOrden';
import { PerformanceEmployee } from './panels/PerformanceEmployee';
import { PerformanceReports_r } from './panels/containers/PerformanceReports_r';
import { Commision } from '../../pages/finance/commisions/Commision';


export const Report = () => {
  //   
  const dispatch = useDispatch();
  const loadFacturas = () => {
    dispatch(startloadAccounts())
  }

  const { usuario, nombre, puesto, avatar, rol } = useSelector(state => state.usuario);

  // console.log(rol);

  const reports = [
    { id: "orders", label: "Ordenes de Servicio y Ventas", component: <SumaryOrders /> },
    { id: "accounts", label: "Cuentas por cobrar", component: <Accounts />, onClick: loadFacturas },
    { id: "performance", label: "Rendimiento", component: <PerformanceReports_r /> },
    { id: "commisions", label: "Comisiones", component: <Commision /> },
    { id: "postOrders", label: "Seguimiento Post Orden", component: <PostOrder /> },
    { id: "postService", label: "Seguimiento Post Servicio", component: <PostService /> },
    { id: "birthdays", label: "Cumpleañeros", component: <Birthdays /> },
    { id: "profitsCustomer", label: "Ganancias por cliente", component: <ProfistCustomer /> },
    { id: "maxminservicios", label: "Servicios Max - Min", component: <MaxMin /> },
    { id: "frecuency", label: "Frecuencia", component: <Frecuencia /> },
    { id: "ingresosByOrden", label: "Ingresos por Orden", component: <IngresosByOrden /> },
  ];


  const visibleByRole = {
    Administrador: reports.map(r => r.id),
    Recepcionista: ["postOrders", "postService", "birthdays"],
    // tecnico: ["orders", "performance", "frecuency"],
  };

  const visibleIds = visibleByRole[rol] || [];
  const visibleReports = reports.filter(r => visibleIds.includes(r.id));


  return (
    <div className='row'>
      <MDetail />
      <div className='col-12'>
        <h3 className="h3 mb-3 fw-bold">Reportes</h3>
      </div>
      {/* ===== LISTA DE REPORTES ===== */}
      <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
        <div className="list-group" id="list-tab" role="tablist">
          {visibleReports.map((report, index) => (
            <a
              key={report.id}
              className={`list-group-item list-group-item-action ${index === 0 ? "active" : ""}`}
              id={`list-${report.id}-list`}
              data-bs-toggle="list"
              href={`#list-${report.id}`}
              onClick={report.onClick}
            >
              {report.label}
            </a>
          ))}
        </div>
      </div>

      {/* ===== CONTENIDO ===== */}
      <div className='col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10'>
        <div className="tab-content" id="nav-tabContent">
          {visibleReports.map((report, index) => (
            <div
              key={report.id}
              className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
              id={`list-${report.id}`}
              role="tabpanel"
              aria-labelledby={`list-${report.id}-list`}
            >
              {report.component}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
